module.exports = __webpack_public_path__ + "static/media/choice-and-control-image-mobile.ea65f56f.svg";